import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Button, CardActions, Chip, Divider, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { putFunnel } from '../Api';
import FunnelConfigDto from '../models/dtos/FunnelConfigDto';

export default function FunnelConfigCard(funnel: FunnelConfigDto) {
    const navigate = useNavigate();
    const [state, setState] = React.useState({funnel : funnel, enabled : funnel.enabled});
    const isStaticReward = funnel.customBetcoins != null;

    const toggleAvailability = async (f: FunnelConfigDto, enabled : boolean) => {
        await putFunnel(f.id, { ...f, enabled: enabled });
        setState({...state, enabled: enabled});
    }

    return (
        <Card sx={{ width: '100%' }} >
            <CardContent sx={{ opacity: state.enabled ? 1.0 : 0.5 }}>
                <Typography gutterBottom variant="h6" component="div" sx={{display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap'}}>
                    {funnel.name}
                    <Chip
                        label={funnel.htmlTemplateId ? 'HTML' : 'Legacy'}
                        size="small"
                        color={funnel.htmlTemplateId ? 'primary' : 'default'}
                        variant={funnel.htmlTemplateId ? 'filled' : 'outlined'}
                    />
                    {funnel.useForSupport && <Chip label='AI support' size="small" color='secondary'/>}
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ color: 'darkGray', textAlign: 'justify' }}>
                    Lifetime: {funnel.lifetime}, Cooldown: {funnel.cooldownTime}, <br/> Daily limit: {funnel.dailyLimit}
                </Typography>
                <Divider />
                <br />
                <Typography variant="body1" color="text.secondary" sx={{ color: 'darkBlue', textAlign: 'justify' }}>
                    User Purchaser Type: {funnel.userPurchaserType}
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ color: 'darkBlue', textAlign: 'justify' }}>
                    Reward configuration: {isStaticReward ? 'Static reward' : 'Dynamic reward'}
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ color: 'darkBlue', textAlign: 'justify' }}>
                    {isStaticReward ? 'Pricing tier' : 'Min pricing tier'}: {funnel.minTier}
                </Typography>
                {funnel.oldPriceTier && <Typography variant="body1" color="text.secondary" sx={{ color: 'darkBlue', textAlign: 'justify' }}>
                    Old price tier: {funnel.oldPriceTier}
                </Typography>}
                {!isStaticReward && <Typography variant="body1" color="text.secondary" sx={{ color: 'darkBlue', textAlign: 'justify' }}>
                    Bonus: +{funnel.bonusSize * 100}%
                </Typography>}
                {funnel.customBetcoins != null && <Typography variant="body1" color="text.secondary" sx={{ color: 'darkBlue', textAlign: 'justify' }}>
                    Custom Betcoins: {funnel.customBetcoins}
                </Typography>}<br />
                <Divider /><br />
                <Typography variant="body1" color="text.secondary" sx={{ color: 'darkGreen', textAlign: 'justify' }}>
                    Activation: {funnel.activationEvents.join(', ')}
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ color: 'darkGreen', textAlign: 'justify', display: 'flex', alignItems: 'center', gap: '4px' }}>
                    OS Types: {funnel.osTypes?.length > 0 ? funnel.osTypes.map(os => (
                        <img key={os} src={os === 'android' ? '/android_logo.png' : '/ios_logo.png'} width={20} height={20} alt={os} />
                    )) : 'All'}
                </Typography><br />
                {(funnel.minBuildNumber != null || funnel.maxBuildNumber != null) && (
                    <Typography variant="body1" color="text.secondary" sx={{ color: 'darkGreen', textAlign: 'justify' }}>
                        Build range: {funnel.minBuildNumber ?? '-'} to {funnel.maxBuildNumber ?? '-'}
                    </Typography>
                )}
                {funnel.userTags.length > 0 && (
                    <React.Fragment>
                        <Typography variant="body1" color="text.secondary" sx={{ color: 'darkGreen', textAlign: 'justify', mt: 1 }}>
                            User tags ({funnel.userTagCombinationMode})
                        </Typography>
                        <Stack direction="row" gap={0.5} flexWrap="wrap" sx={{ mt: 1 }}>
                            {funnel.userTags.map(tag => (
                                <Chip key={tag} label={tag} size="small" variant="outlined" />
                            ))}
                        </Stack>
                    </React.Fragment>
                )}
                <Divider />
            </CardContent>
            <CardActions >
                <Button size="small" color="primary" variant="contained" sx={{ marginLeft: 'auto', color: 'white' }} onClick={e => toggleAvailability(state.funnel, !state.enabled)}>
                    {state.enabled ? 'Disable' : 'Enable'}
                </Button>
                <Button size="small" color="primary" variant="outlined" sx={{ marginLeft: 'auto' }} onClick={e => navigate('/funnels/' + funnel.id + '/edit')}>
                    Edit
                </Button>
            </CardActions>
        </Card>
    );
}
